var clockIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 18 18\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#7F91A5\" stroke-linecap=\"square\" transform=\"translate(1 1)\">\n        <circle cx=\"8\" cy=\"8\" r=\"7.652\"/>\n        <path d=\"M8 3.826V8h4.174\"/>\n    </g>\n</svg>";

export { clockIcon as default };
